export default [
    {
        path: '/integrations/entra-id',
        name: 'integrations-entra-id',
        component: () => import ('./views/AzureIdConfiguration.vue'),
        meta: {
            title: 'Configurações do Microsoft Entra ID',
            icon: 'mdi-monitor-lock',
            breadcrumbs: [
                { text: 'Cadastros das configurações para utilização do Entra ID na instituição', disabled: true }
            ]
        }
    },
]
